import PlataformApi from "@/services/plataformApi"

const Notification = {
  components: {
    PlataformApi
  },

  state: () => ({
    notifications: [],
    newNotification: '',
  }),

  getters: {
    notifications: state => {
      return state.notifications
    }
  },

  mutations: {
    setNotifications (state, notifications) {
      state.notifications = notifications
    },

    setNewNotification (state, newNotification) {
      state.newNotification = newNotification
    }
  },

  actions: {
    async registerAccess (id) {
      await PlataformApi.registerAccess(id)
    },

    async registerVisualization (id) {
      await PlataformApi.registerVisualization(id)
    }
  }
};

export default Notification;